<ul class="link-list link-list--horizontal">
    <li *ngIf="username$" class="link-list__item user-info__block">
        <p>{{username$ | async }}</p>
        <div class="logout__block">
            <a  [routerLink]="getLoginRouterLink()" title="{{'buttons.logout' | translate}}" class="link logout-btn" (click)="logout()">
                <i class="icon icon-logout"></i>
            </a>
        </div>
    </li>
    <li class="link-list__item language__block">
        <app-languages-selector></app-languages-selector>
    </li>   
</ul>
  
